import {
  getAllServices as get_all_services,
  getServiceReviews as get_service_reviews
} from "./services";
import {
  createOrUpdateOrder as create_or_update_order,
  checkAddress as check_address,
  checkEmail as check_email,
  confirmOrder as confirm_order,
  getOrderDetails as get_orderDetails,
  get_cleaner_time,
  getOrderPrice as get_order_price,
  setOngoing as set_ongoing,
  setStatus as set_status,
  getDisabledDates as get_disabled_dates
} from "./order";
import {
  getSystemSettings as get_system_settings,
  getBenefitBarHTML as get_benefit_bar_html
} from "./settings";

export const createOrUpdateOrder = create_or_update_order;
export const checkAdress = check_address;
export const checkEmail = check_email;
export const getCleanerTime = get_cleaner_time;
export const getAllServices = get_all_services;
export const getServiceReviews = get_service_reviews;
export const setOngoing = set_ongoing;
export const setStatus = set_status;
export const getOrderPrice = get_order_price;
export const confirmOrder = confirm_order;
export const getOrderDetails = get_orderDetails;
export const getSystemSettings = get_system_settings;
export const getDisabledDates = get_disabled_dates;
export const getBenefitBarHTML = get_benefit_bar_html;
